import reducer from "./reducers";

import * as labtesttypeAction from "./actions";

export { labtesttypeAction };

export default reducer;
